import { render, staticRenderFns } from "./Registrarse.vue?vue&type=template&id=5fd2b326&scoped=true"
import script from "./Registrarse.vue?vue&type=script&lang=js"
export * from "./Registrarse.vue?vue&type=script&lang=js"
import style0 from "./Registrarse.vue?vue&type=style&index=0&id=5fd2b326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd2b326",
  null
  
)

export default component.exports